export default __webpack_public_path__ + "static/media/Ubuntu-RI.0ebb431f.woff";